const menuButton = document.querySelector('#burger-button');
const iconOpen = menuButton.querySelector('.header-open-drawer');
const iconClose = menuButton.querySelector('.header-close-drawer');

const fullMenu = document.querySelector('#mobile-full-nav');
const mobileNavBar = document.querySelector('#nav-bar');
const navBar = document.querySelector('.navbar');

const header = document.querySelector('.header');

const headerWrapper = document.querySelector('.header-navs-wrap');

const desktopNavigation = document.querySelector('.header-nav-block.desktop-nav');

const initDesktopNavWidth = desktopNavigation.clientWidth;

let collapseWidth = 3000;

let isCollapseCalculated = false;

let isOpened = false;

const checkHeaderOverflowing = () => {
  const isHeaderOverflowing = !isCollapseCalculated ? initDesktopNavWidth > headerWrapper.clientWidth - 150 : window.innerWidth < collapseWidth;

  if (window.innerWidth < 767 || isHeaderOverflowing) {
    if (!isCollapseCalculated) {
      isCollapseCalculated = true;
      collapseWidth = headerWrapper.clientWidth + 150;
    }
    
    desktopNavigation.classList.add('hidden');
    header.classList.add('mobile');
  } else {
    desktopNavigation.classList.remove('hidden');
    header.classList.remove('mobile');
  }

  navBar.classList.remove('invisible');
}

const open = () => {
    iconOpen.classList.add('hidden');
    iconClose.classList.remove('hidden');
  
    mobileNavBar.classList.add('opened');
  
    fullMenu.classList.remove('hidden');
    setTimeout(() => {
      fullMenu.classList.add('opened');
    }, 5);
};

const close = () => {
    iconOpen.classList.remove('hidden');
    iconClose.classList.add('hidden');

    mobileNavBar.classList.remove('opened');

    fullMenu.classList.remove('opened');
    setTimeout(() => {
    fullMenu.classList.add('hidden');
    }, 405);
};

setTimeout(() => {
  checkHeaderOverflowing();
}, 100)


menuButton.addEventListener('click', () => {
  if (isOpened) {
      close();
  } else {
      open();
  };
  
  isOpened = !isOpened;
});

window.addEventListener('resize', () => {
  checkHeaderOverflowing();
  
  if (window.innerWidth > 767) {
    // fullMenu.classList.add('hidden');
    close();
  }
});


const updateCartUIState = () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const isEmpty = cart.item_count === 0;
      
      const emptyState = document.querySelector('.mob-only.empty-cart');
      const filledState = document.querySelector('.mob-only.cart');

      if (emptyState && filledState) {
        if (isEmpty) {
          emptyState.classList.remove('hidden');
          filledState.classList.add('hidden');
        } else {
          emptyState.classList.add('hidden');
          filledState.classList.remove('hidden');
        }
      }
    });
}

document.addEventListener(_EVENT_HELPER.triggerCartChange, () => {
  updateCartUIState();
});
